var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26367 4.35141C4.26367 3.79912 4.71139 3.35141 5.26367 3.35141H16.9111C17.4634 3.35141 17.9111 3.79913 17.9111 4.35141V20.6486H5.26367C4.71139 20.6486 4.26367 20.2009 4.26367 19.6486V4.35141Z",
    stroke: "currentColor",
    strokeWidth: 1.57,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2988 11.5168C21.2988 10.9645 20.8511 10.5168 20.2988 10.5168H17.9102V20.6486H20.2988C20.8511 20.6486 21.2988 20.2009 21.2988 19.6486V11.5168Z",
    stroke: "currentColor",
    strokeWidth: 1.57,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 7.65033H11.1977",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 11.5561H12.7809",
    stroke: "currentColor",
    strokeWidth: 1.32374,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/主档管理.efec90c767ba2ebdc463fa0131edde2c.svg";
export { ForwardRef as ReactComponent };